webpackJsonp([78],{

/***/ 1368:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1369);


/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(212);

var _datetime2 = _interopRequireDefault(_datetime);

var _enCa = __webpack_require__(850);

var _enCa2 = _interopRequireDefault(_enCa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en-ca', _enCa2.default);

/***/ })

},[1368]);


// WEBPACK FOOTER //
// app/datetime.en-ca-09d8ef1a63ab859a72a3.js